/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgSmile(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M12 2.75a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12zm7-3A.75.75 0 019 8.25h.01a.75.75 0 010 1.5H9A.75.75 0 018.25 9zm6 0a.75.75 0 01.75-.75h.01a.75.75 0 010 1.5H15a.75.75 0 01-.75-.75zm-6.78 4.47a.75.75 0 011.06 0c.051.05.106.107.165.169.575.597 1.552 1.611 3.305 1.611 1.754 0 2.73-1.014 3.305-1.611l.165-.17a.75.75 0 111.06 1.061l-.14.146c-.568.6-1.964 2.074-4.39 2.074-2.426 0-3.822-1.474-4.39-2.074a8.281 8.281 0 00-.14-.146.75.75 0 010-1.06z'
      />
    </svg>
  );
}

export default SvgSmile;
